import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { BenefitsSection } from '../components/BenefitsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#00D4FF] selection:text-black" data-id="element-470">
      <Navigation data-id="element-471" />
      <main data-id="element-472">
        <Hero data-id="element-473" />
        <BenefitsSection data-id="element-474" />
        <CTASection data-id="element-475" />
      </main>
      <Footer data-id="element-476" />
    </div>;
}